/**
 * Screen 스타일
 * @description 껍데기가 가진 것은 배경과 콘텐츠 열의 최대 폭뿐이다. **좌우는 다루지 않는다** —
 *   가로 리듬은 `Section` 이 맡는다(앱과 같은 결정). 앱의 SafeArea 인셋은 웹에 없다.
 *
 *   `fw-screen` 은 전역 스타일이 붙잡는 표식이다 — 오버스크롤로 드러나는 `body` 캔버스는
 *   자식이 칠할 수 없어서 `globals.css` 가 이 클래스를 보고 칠한다.
 */
import { cva } from "class-variance-authority";

export const screenStyles = {
  root: cva(
    "fw-screen flex min-h-dvh w-full flex-col font-app text-[var(--fw-color-content-neutral-primary)]",
    {
      variants: {
        background: {
          primary: "bg-[var(--fw-color-surface-neutral-primary)]",
          secondary: "bg-[var(--fw-color-surface-neutral-secondary)]",
        },
        /* 표식만 남긴다 — 스크롤바는 html 의 것이라 globals.css 가 `:has()` 로 감춘다 */
        hideScrollbar: { true: "fw-screen--no-scrollbar", false: "" },
      },
      defaultVariants: { background: "primary", hideScrollbar: false },
    },
  ),
  /** 콘텐츠 열 — 넓은 화면에서 가운데 모이고, 폰 폭에서는 폭을 다 쓴다 */
  column:
    "mx-auto flex w-full max-w-[var(--fw-content-max-width)] flex-1 flex-col",
};
